// src/components/barLounge/CocktailItem.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ingredientIcons } from '../../data/barMenuData';

const CocktailItem = ({ name, price, ingredients, glass }) => {
  const navigate = useNavigate();
  
  const getIngredientIcon = (ingredientName) => {
    for (const key in ingredientIcons) {
      if (ingredientName.toLowerCase().includes(key.toLowerCase())) {
        return ingredientIcons[key];
      }
    }
    return ingredientIcons.default;
  };

  const handleClick = () => {
    if (ingredients && ingredients.length > 1) {
      navigate(`/facilities/bar-lounge/${encodeURIComponent(name)}`);
    }
  };

  return (
    <div className="menu-item" onClick={handleClick} style={{ cursor: ingredients && ingredients.length > 1 ? 'pointer' : 'default' }}>
      <div className="item-details">
        <span className="item-name">{name}</span>
        {ingredients && ingredients.length > 0 && (
          <div className="ingredients">
            {ingredients.map((ing, index) => (
              <span key={index} title={ing} className="ingredient-icon">
                {getIngredientIcon(ing)}
              </span>
            ))}
            ({ingredients.join(' + ')})
          </div>
        )}
      </div>
      <div className="item-meta">
        <span className="item-price">¥{typeof price === 'number' ? price.toLocaleString() : price}</span>
        {glass && <span className="item-glass">{glass}</span>}
      </div>
    </div>
  );
};

export default CocktailItem;